import { defineStore } from 'pinia'
import axios from '../config/api.js'

export const useNotificationChannelsStore = defineStore('notificationChannels', {
  state: () => ({
    channels: [],
    deliveryAttempts: {},
    loading: false,
    error: null,
  }),

  actions: {
    async fetchChannels() {
      this.loading = true
      this.error = null
      try {
        const response = await axios.get('/api/notification-channels')
        this.channels = response.data
        return { success: true }
      } catch (error) {
        this.error = error.response?.data?.detail || 'Failed to load notification channels'
        return { success: false, message: this.error }
      } finally {
        this.loading = false
      }
    },

    async createChannel(data) {
      this.loading = true
      this.error = null
      try {
        const response = await axios.post('/api/notification-channels', data)
        this.channels.push(response.data)
        return { success: true, data: response.data }
      } catch (error) {
        const message = error.response?.data?.detail || 'Failed to create channel'
        this.error = message
        return { success: false, message, violations: error.response?.data?.violations }
      } finally {
        this.loading = false
      }
    },

    async updateChannel(id, data) {
      this.loading = true
      this.error = null
      try {
        const response = await axios.put(`/api/notification-channels/${id}`, data)
        const idx = this.channels.findIndex(c => c.id === id)
        if (idx !== -1) this.channels[idx] = response.data
        return { success: true, data: response.data }
      } catch (error) {
        const message = error.response?.data?.detail || 'Failed to update channel'
        this.error = message
        return { success: false, message, violations: error.response?.data?.violations }
      } finally {
        this.loading = false
      }
    },

    async deleteChannel(id) {
      this.loading = true
      this.error = null
      try {
        await axios.delete(`/api/notification-channels/${id}`)
        this.channels = this.channels.filter(c => c.id !== id)
        return { success: true }
      } catch (error) {
        const message = error.response?.data?.detail || 'Failed to delete channel'
        this.error = message
        return { success: false, message }
      } finally {
        this.loading = false
      }
    },

    async sendTest(id) {
      this.error = null
      try {
        const response = await axios.post(`/api/notification-channels/${id}/test`, {})
        return { success: response.data.success, message: response.data.message, httpStatus: response.data.httpStatus }
      } catch (error) {
        const message = error.response?.data?.message || 'Test failed'
        this.error = message
        return { success: false, message }
      }
    },

    async fetchDeliveryAttempts(id) {
      this.error = null
      try {
        const response = await axios.get(`/api/notification-channels/${id}/delivery-attempts`)
        this.deliveryAttempts[id] = response.data
        return { success: true, data: response.data }
      } catch (error) {
        const message = error.response?.data?.message || 'Failed to load delivery attempts'
        this.error = message
        return { success: false, message }
      }
    },

    clearError() {
      this.error = null
    },
  },
})
